import { useContext } from 'react';
import { createContext } from 'react';

import { ShareProps } from '../@types/ShareProps';

export const ShareContext = createContext<ShareProps>({} as ShareProps);

ShareContext.displayName = 'Share';

const ShareProvider = (props: ShareProps) => (
	<ShareContext.Provider value={props}>{props.children}</ShareContext.Provider>
);

export const useShare = () => {
	const context = useContext(ShareContext);

	return context;
};

export default ShareProvider;
